import React, { useMemo } from 'react';
import {
    MaterialReactTable,
    useMaterialReactTable,
} from 'material-react-table';
import "./DynamicForm.scss";
import FuelEUMonitoringHeader from './FuelEUMonitoringHeader';




const FuelMonitoringPlanTable = () => {
    const FueleuColumns = useMemo(
        () => [
            {
                header: "Form State",
                enableHiding: false,
                accessorKey: "formState",
            },
            {
                header: "Version No.",
                accessorKey: "versionNo",
            },
            {
                header: "Reference Date",
                accessorKey: "referenceDate",
                enableSorting: false,
            },
            // {
            //     header: "Year of Installation",
            //     accessorKey: "yearOfInstallation",
            //     enableSorting: false,
            // },
            {
                header: "IMO No.",
                accessorKey: "imoNo",
                enableSorting: false,
            },
            {
                header: "Name of Ship",
                enableHiding: false,
                accessorKey: "nameOfShip",
            },
            {
                header: "Submitted By",
                accessorKey: "submitedBy",
            },
        ],
        []
    );

    const fuelEuTable = useMaterialReactTable({
        columns: FueleuColumns,
        data: [],
        enableSorting: false,
        enableFilters: false,
        enablePagination: false,
        enableRowSelection: false,
        enableColumnActions: false,
        enableDensityToggle: false,
        enableFullScreenToggle: false,



        muiTableHeadCellProps: ({ column }) => ({
            id: `${column.columnDef.accessorKey}`,
            style: { backgroundColor: '#002a4e' },
            sx: {
                color: "rgb(255 255 255)",

                "& .MuiButtonBase-root": {
                    color: "white !important",
                    "& .MuiTableSortLabel-icon": {
                        color: "white !important",
                    },
                },
                "& .MuiInputAdornment-root": {
                    "& .Mui-disabled": {
                        color: "darkgrey !important",
                    },
                },
            },
        }),
    });

    return (
        <div className="p-4" >
            <FuelEUMonitoringHeader/>
            <div className="mt-2">
            <MaterialReactTable table={fuelEuTable} />


            </div>
        </div>
    );
};

export default FuelMonitoringPlanTable;